module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="phx-formTable">\n  <div class="phx-formErrors ui-state-error"></div>\n  <div>\n    <div class="phx-lanceetat-details-header-text">\n      <label class="phx-lanceetat-header-selected phx-details-header-text"></label>\n    </div>\n  </div>\n</div>';
}
return __p;
};
